import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { SYS_ADMIN } from 'config/permissions/roles';
import categories from './categories/categories.module';
import companies from './companies/companies.module';
import company from './company/company.module';
import mapCategories from './map-categories/map-categories.module';
import mapIngredients from './map-ingredients/map-ingredients.module';
import memberCompliance from './member-compliance/member-compliance.module';
import memberComplianceProcess from './member-compliance/member-compliance-process.module';
import regulator from './regulator/regulator.module';
import userIngredients from './user-ingredients/user-ingredients.module';
import systemIngredients from './system-ingredients/system-ingredients.module';

export default
  angular.module('components.app.admin', [
    uiRouter,
    categories,
    companies,
    company,
    mapCategories,
    mapIngredients,
    memberCompliance,
    memberComplianceProcess,
    regulator,
    userIngredients,
    systemIngredients
  ])
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('admin', {
          parent: 'app',
          template: '<ui-view flex layout="column"></ui-view>',
          url: '/admin',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    }).name;



// WEBPACK FOOTER //
// ./components/app/admin/admin.module.js